import React, {memo} from 'react';
import '../../Styles/Annotator/ubersicht.css';
import DisplayDetailsComponent from './DisplayDetailsComponent';

class ReportDetailComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            keyData: [],
            load: false
        };
    }

    async componentDidMount() {
        //hasToken();

        //TODO: after integrations to paas
        //TODO: create a function that returns report link attributes
        //let path = window.location.pathname;
        //let lvID = path.split('/')[2];
        //let link = await getReportLink(lvID);
        //link = link.response;
        //let data = await getRepLinkApi(window.location.pathname);
        //let data = await getReportDetail(lvID, this.props.type)
        //let msg_frombackend = process.env.REACT_APP_BASE_INVALID_REPORTLINK_MSG;
        //let msg_todisplay = process.env.REACT_APP_BASE_INVALID_REPORTLINK_MSGTODISPLAY;
        //if (data.message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
        //getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
        //}
        //if (data.message === msg_frombackend) {
        //return null;
        //}


        let renderer = '';
        if (this.props.type === 'Hinweis') {
            renderer = (
                <div className="block_container">
                    <DisplayDetailsComponent
                        lvInfo={this.props.lvInfo}
                                        annotationData={this.props.annotationData}


                        setIsIndividualPDFActive={this.props.setIsIndividualPDFActive}
                        setHinweisContent={this.props.setHinweisContent}
                        setHinweisSelectedAGLs={this.props.setHinweisSelectedAGLs}
                        hinweisSelectedAGLs={this.props.hinweisSelectedAGLs}
                        hinweisIndividualContent={this.props.hinweisIndividualContent}
                        setHinweisIndividualContent={this.props.setHinweisIndividualContent}
                        type={this.props.type}
                        theLVID={this.props.lvID}
                        pageData={this.props.pageData}
                        projectName={this.props.projectName}
                        detailType={"Hinweis"}
                        content={this.props.hinweisContent}
                    />
                </div>
            );
        } else if (this.props.type === 'Potenzial') {
            renderer = (
                <div className="block_container">
                    <DisplayDetailsComponent
                        lvInfo={this.props.lvInfo}
                                        annotationData={this.props.annotationData}

                        setIsIndividualPDFActive={this.props.setIsIndividualPDFActive}
                        setPotenzialContent={this.props.setPotenzialContent}
                        setPotenzialSelectedAGLs={this.props.setPotenzialSelectedAGLs}
                        potenzialSelectedAGLs={this.props.potenzialSelectedAGLs}
                        potenzialIndividualContent={this.props.potenzialIndividualContent}
                        setPotenzialIndividualContent={this.props.setPotenzialIndividualContent}
                        type={this.props.type}
                        theLVID={this.props.lvID}
                        pageData={this.props.pageData}
                        projectName={this.props.projectName}
                        detailType={"Potenzial"}
                        content={this.props.potenzialContent}
                    />
                </div>
            );
        } else if (this.props.type === 'Risiko') {
            renderer = (
                <div className="block_container">
                    <DisplayDetailsComponent
                        lvInfo={this.props.lvInfo}
                                        annotationData={this.props.annotationData}

                        setIsIndividualPDFActive={this.props.setIsIndividualPDFActive}
                        setRisikoContent={this.props.setRisikoContent}
                        setRisikoSelectedAGLs={this.props.setRisikoSelectedAGLs}
                        risikoSelectedAGLs={this.props.risikoSelectedAGLs}
                        risikoIndividualContent={this.props.risikoIndividualContent}
                        setRisikoIndividualContent={this.props.setRisikoIndividualContent}
                        type={this.props.type}
                        theLVID={this.props.lvID}
                        pageData={this.props.pageData}
                        projectName={this.props.projectName}
                        detailType={"Risiko"}
                        content={this.props.risikoContent}
                    />
                </div>
            );
        } else {
            renderer = <div>Bitte überprüfen Sie die Rendering-Daten.</div>;
        }

        this.setState({keyData: renderer});
    }

    render() {
        return <div>{this.state.keyData}</div>;
    }
}

export default memo(ReportDetailComponent);
